import { GUID } from "../../../helpers/guid.helper";

export class AddEditPaymentDto {
    Id: string;
    FirstName: string;
    LastName: string;
    DocumentNumber: string;
    IsActive: boolean;
    Payments: any[];
    DivisionId: number;
    SchoolYearId: number;
    
    constructor() {
        this.Id = GUID.newGuid();
        this.FirstName = 's';
        this.LastName = 'd';
        this.DocumentNumber = '2';
        this.IsActive = false;
        this.IsActive = true;
        this.Payments = [];
        this.DivisionId = 1;
        this.SchoolYearId = undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/students/dto/AddEditPaymentDto.ts